import React, { useState, useContext, useEffect } from "react";
import "./StepTwo.scss";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";

import Elements from "../Elements/Elements";
// import single from "../../assets/single.svg";
// import lshape from "../../assets/l-shape.svg";
// import ushape from "../../assets/u-shape.svg";
// import ushapeIsland from "../../assets/u-shapeIsland.svg";
// import lshapeIsland from "../../assets/l-shapeIsland.svg";
import plusshape from "../../assets/plusshape.svg";
import { SquareContext } from "../../SquareContext";
import { ShapeContext } from "../../ShapeContext";
import cx from "classnames";

function Steptwo(props) {
  const {
    listShape,
    shape,
    btnColor2,
    removeDimensionState,
    stepDesc,
    cart,
  } = useContext(SquareContext);
  const {
    setBox1c,
    setBox2c,
    setBox3c,
    setBox4c,
    setBox1r,
    setBox2r,
    setBox3r,
    setBox4r,
    setBox1l,
    setBox2l,
    setBox3l,
    setBox4l,
    setBox1t,
    setBox2t,
    setBox3t,
    setBox4t,
    setBox1is,
    setBox2is,
    setBox3is,
    setBox4is,
  } = useContext(ShapeContext);
  const removeBoxes = () => {
    if (shape.find((obj) => obj.id === 1)) {
      setBox1r(false);
      setBox2r(false);
      setBox3r(false);
      setBox4r(false);
      setBox1l(false);
      setBox2l(false);
      setBox3l(false);
      setBox4l(false);
      setBox1t(false);
      setBox2t(false);
      setBox3t(false);
      setBox4t(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    } else if (shape.find((obj) => obj.id === 2)) {
      setBox4c(false);
      setBox1l(false);
      setBox2l(false);
      setBox3l(false);
      setBox4l(false);
      setBox1t(false);
      setBox2t(false);
      setBox3t(false);
      setBox4t(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    } else if (shape.find((obj) => obj.id === 3)) {
      setBox2c(false);
      setBox4c(false);
      setBox1t(false);
      setBox2t(false);
      setBox3t(false);
      setBox4t(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    } else if (shape.find((obj) => obj.id === 4)) {
      setBox2c(false);
      setBox4c(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    } else if (shape.find((obj) => obj.id === 5)) {
      setBox4c(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
      setBox1l(false);
      setBox2l(false);
      setBox3l(false);
      setBox4l(false);
    } else if (shape.find((obj) => obj.id === 6)) {
      setBox2c(false);
      setBox4c(false);
      setBox4t(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    } else if (shape.find((obj) => obj.id === 7)) {
      setBox2c(false);
      setBox4c(false);
      setBox4t(false);
    } else if (shape.find((obj) => obj.id === 1)) {
      setBox1r(false);
      setBox2r(false);
      setBox3r(false);
      setBox4r(false);
      setBox1l(false);
      setBox2l(false);
      setBox3l(false);
      setBox4l(false);
      setBox1is(false);
      setBox2is(false);
      setBox3is(false);
      setBox4is(false);
    }
  };

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  function handleSubmit(event) {
    event.preventDefault();
  }

  function handleNext() {
    if (shape.length != 0) {
      props.next();
      removeDimensionState();
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepTwo">
   

        {stepDesc[1] && (
        <div>
          <div className="head">
            <p className="head-red">STEP 2</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[1].title }}></p>
          </div>
        </div>
      )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 2) {
                props.jump(1);
              } else {
                props.jump(2);
              }
            }}
            second={() => {
              if (props.order === 2) {
                props.jump(1);
              } else {
                props.jump(2);
              }
            }}
            third={() => {
              if (props.order === 2) {
                props.jump(1);
              } else {
                props.jump(2);
              }
            }}
          />
          {stepDesc[1] !== undefined && (
            <div
              className="text-middle"
              dangerouslySetInnerHTML={{ __html: stepDesc[1].description }}
            ></div>
          )}
              <div className="buttons">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={() => {
                  handleNext();
                  removeBoxes();
                }}
                style={{ background: btnColor2 }}
              >
                NEXT STEP
              </button>
            </div>
        </div>
        <div className="shapes">
          <Elements eleclass="elements" />
          <div className="shapes-form-container">
            <div className="shapes-form shape2left">
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 1) ? "active" : ""
                )}
              >
                {listShape[0]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 2) ? "active" : ""
                )}
              >
                {listShape[1]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 3) ? "active" : ""
                )}
              >
                {listShape[2]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 4) ? "active" : ""
                )}
              >
                {listShape[3]}
              </div>
              <div
                className={cx(
                  "mrg-cont twolsh",
                  shape.find((obj) => obj.id === 5) ? "active" : ""
                )}
              >
                {listShape[4]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 6) ? "active" : ""
                )}
              >
                {listShape[5]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 7) ? "active" : ""
                )}
              >
                {listShape[6]}
              </div>
              <div
                className={cx(
                  "mrg-cont",
                  shape.find((obj) => obj.id === 8) ? "active" : ""
                )}
              >
                {listShape[7]}
              </div>
              {/* <form onSubmit={handleSubmit}>
              <input type="radio" value="singleRun" name="shape"></input>
              <label for="singleRun">SINGLE RUN</label>
              <input type="radio" value="singleRun" name="shape"></input>
              <label for="singleRun">L-SHAPE</label>
            </form> */}
            </div>
            <div className="btn-down">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={() => {
                  handleNext();
                  removeBoxes();
                }}
                style={{ background: btnColor2 }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
        <div>
        
        </div>
      </div>
    </>
  );
}

export default Steptwo;
